import React from 'react';
import { InstagramIcon, TiktokIcon, YoutubeIcon, FacebookIcon } from '@revfluence/fresh-icons/brands/esm';
import type { SocialNetwork } from '@/applications/Social/types/social-network';

export interface PlatformIconProps {
  /** The platform to display (e.g., 'instagram', 'tiktok', 'youtube', 'facebook') */
  platform: SocialNetwork;
  /** Optional CSS classes for styling */
  className?: string;
}

/**
 * PlatformIcon
 * ------------
 * A reusable component for displaying platform-specific icons across the application.
 * Supports Instagram, TikTok, YouTube, and Facebook platforms.
 *
 * Usage:
 * ```tsx
 * <PlatformIcon platform="instagram" className="h-5 w-5" />
 * ```
 */
export const PlatformIcon: React.FC<PlatformIconProps> = ({
  platform,
  className = 'h-5 w-5',
}) => {
  switch (platform) {
    case 'instagram':
      return <InstagramIcon className={className} />;
    case 'tiktok':
      return <TiktokIcon className={className} />;
    case 'youtube':
      return <YoutubeIcon className={className} />;
    case 'facebook':
      return <FacebookIcon className={className} />;
    default:
      return null;
  }
};

export default PlatformIcon;
